import { useEffect, useState } from 'react'
import classnames from 'classnames'
import CircleLoader from '@components/CircleLoader'
import TableCell from '@components/TableCell'
import TableRow from '@components/Table/TableRow'
import Button from '@components/Button'
import IconButton from '@components/IconButton'

import PaymentModal from 'dashboard-subscriptions/components/PaymentModal'
import SubscriptionModalFooter from 'dashboard-subscriptions/components/SubscriptionModalFooter'

import { getSubscriptionReceipts, downloadReceipt } from 'dashboard-subscriptions/actions'
import { subscriptionReceiptsLoadingSelector, subscriptionReceiptsSelector } from 'dashboard-subscriptions/selectors'
import { INVOICE_PAYMENT_PROGRESS } from 'dashboard-subscriptions/constants'
import InvoicesHeader from 'dashboard-subscriptions/components/InvoicesTab/InvoicesHeader'

import styles from '../styles.module.scss'

const ReceiptsTab = ({
    subscriptionId,
    subscriptionsLoading,
    getSubscriptionReceipts,
    closeModal,
    downloadReceipt,
    subscriptionReceipts,
}) => {
    useEffect(() => {
        getSubscriptionReceipts(subscriptionId)
    }, [])

    return (
        <>
            <div className={styles.invoicesTable}>
                <div className={classnames('table', 'table-hover')}>
                    <InvoicesHeader isInvoicesTab={false} />
                    {subscriptionsLoading ? (
                        <div className="d-flex justify-content-center mt-4 pb-4">
                            <CircleLoader size="medium" />
                        </div>
                    ) : (
                        subscriptionReceipts?.map((receipt, index) => (
                            <TableRow key={index} className={classnames(styles.invoiceRow)}>
                                <TableCell
                                    className={styles.invoice}
                                    fieldName={<T>dashboard.subscriptions.invoices.invoice</T>}
                                    titleClassName="smallTableHeader">
                                    <div
                                        onClick={() => downloadReceipt(subscriptionId, receipt.number, 'en')}
                                        className="d-flex align-items-center ml-0"
                                        role="button">
                                        <IconButton icon="download" />
                                        {receipt.number}
                                    </div>
                                </TableCell>
                                <TableCell
                                    fieldName={<T>dashboard.subscriptions.invoices.due.date</T>}
                                    titleClassName="smallTableHeader">
                                    {receipt.effectiveDate}
                                </TableCell>
                                <TableCell
                                    className={classnames(styles.amount)}
                                    fieldName={<T>dashboard.subscriptions.invoices.amount</T>}
                                    titleClassName="smallTableHeader">
                                    ${receipt.amount}
                                </TableCell>
                                <TableCell
                                    fieldName={<T>dashboard.subscriptions.invoices.status</T>}
                                    titleClassName="smallTableHeader">
                                    {receipt.status}
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </div>
            </div>
            <SubscriptionModalFooter closeModal={closeModal} />
        </>
    )
}
export default compose(
    connect(
        createStructuredSelector({
            subscriptionsLoading: subscriptionReceiptsLoadingSelector,
            subscriptionReceipts: subscriptionReceiptsSelector,
        }),
        { getSubscriptionReceipts, downloadReceipt }
    )
)(ReceiptsTab)
